import { resizeImage } from '@mc/resize-image'
import classes from './InstructorImage.module.scss'

export const IMG_DIM = 40

type InstructorImageProps = {
  primary1x1: string
  className?: string
}

export const InstructorImage = ({
  primary1x1,
  className = '',
}: InstructorImageProps) => (
  // not using next/image so that we can preload images even before it is rendered
  // ... even more eager than `loading='eager'`
  <img
    src={getInstructor1x1ImgSrc(primary1x1)}
    className={`${className} ${classes.instructorImage} mc-corners--1`}
    alt=''
    width={IMG_DIM}
    height={IMG_DIM}
  />
)

export const getInstructor1x1ImgSrc = (primary1x1: string) =>
  resizeImage(primary1x1, {
    width: IMG_DIM,
    height: IMG_DIM,
    quality: 80,
    dpr: 2,
  }) || ''
